import * as lodash from 'lodash';
import { deepDiff } from 'webui/utils/objects';
import { generateMongoDBId } from 'console/utils/mongo-db';
import { getZ3kEntityById } from 'z3k-parser/lib';
export function deepConfigCompare(general_compare_result, exist_config) {
    if (Object.keys(general_compare_result).length === 0) {
        return null;
    }
    let count = 0;
    const result = Object.keys(general_compare_result).reduce((resultAcc, key) => {
        //если результат сравнения объект ищем такой же в старом конфиге и записываем оба варианта в объект с ключами new и old
        if (lodash.isPlainObject(general_compare_result[key])) {
            const newResult = deepDiff(general_compare_result[key] ?? {}, exist_config[key] ?? {});
            if (Object.keys(newResult).length > 0) {
                let oldResult = {};
                Object.keys(newResult).map((i) => {
                    count = count + 1;
                    const objectOldConfig = exist_config[key];
                    if (objectOldConfig) {
                        return (oldResult = {
                            ...oldResult,
                            [i]: objectOldConfig[i],
                        });
                    }
                    else
                        return;
                });
                const id = generateMongoDBId();
                resultAcc = [
                    ...resultAcc,
                    { old: oldResult, new: newResult, id: id, key: key },
                ];
            }
        }
        //если результат сравнения массив ищем такой же в старом конфиге и записываем оба варианта в объект с ключами new и old, также ищем удаленные и добавленные объекты
        if (Array.isArray(general_compare_result[key])) {
            general_compare_result[key]?.map((el) => {
                const findObjectOldConfig = (el.id &&
                    exist_config[key]?.find((i) => i.id === el.id)) ??
                    null; // null если не нашли объект, значит нужно добавить как новый
                //ищем heating_zones единственный массив в объекте массива в объекте...
                let newNesterArr = [];
                let oldNesterArr = [];
                const nesteredHeatingZones = lodash.get(el, 'heating_zones', null);
                //обрабатываем его
                if (nesteredHeatingZones && findObjectOldConfig) {
                    nesteredHeatingZones.map((elem) => {
                        const objectOldConfig = findObjectOldConfig.heating_zones.find((e) => e.heating_circuit === elem.heating_circuit);
                        const [, z3k_itemNew] = getZ3kEntityById(exist_config, elem.heating_circuit);
                        if (objectOldConfig) {
                            const newObj = deepDiff(elem, objectOldConfig);
                            if (Object.keys(newObj).length > 0) {
                                count = count + 1;
                                const id = generateMongoDBId();
                                for (const key in newObj) {
                                    oldNesterArr = [
                                        ...oldNesterArr,
                                        {
                                            settings: {
                                                [key]: objectOldConfig[key],
                                            },
                                            name: z3k_itemNew
                                                ?.name,
                                            id: id,
                                            idSensor: elem.heating_circuit,
                                        },
                                    ];
                                }
                                return (newNesterArr = [
                                    ...newNesterArr,
                                    {
                                        settings: newObj,
                                        id: id,
                                        name: z3k_itemNew?.name,
                                        idSensor: elem.heating_circuit,
                                    },
                                ]);
                            }
                            return newNesterArr;
                        }
                        else {
                            const id = generateMongoDBId();
                            return (newNesterArr = [
                                ...newNesterArr,
                                {
                                    settings: {
                                        ...elem,
                                    },
                                    id: id,
                                    name: z3k_itemNew?.name,
                                    flag: 'Добавлен',
                                    idSensor: elem.heating_circuit,
                                },
                            ]);
                        }
                    });
                    // ищем удаленный объект в старом конфиге
                    const findDeleteObjOldConfig = lodash.differenceBy(findObjectOldConfig.heating_zones, nesteredHeatingZones, 'heating_circuit');
                    if (findDeleteObjOldConfig.length > 0) {
                        //добавляем в результат сравнения удаленный объект
                        findDeleteObjOldConfig.map((el) => {
                            const [, z3k_itemOld] = getZ3kEntityById(exist_config, el.heating_circuit);
                            const id = generateMongoDBId();
                            return (newNesterArr = [
                                ...newNesterArr,
                                {
                                    settings: {
                                        ...el,
                                    },
                                    id: id,
                                    name: z3k_itemOld?.name,
                                    flag: 'Удален',
                                    idSensor: el.heating_circuit,
                                },
                            ]);
                        });
                    }
                }
                const newEl = lodash.omit(el, 'heating_zones');
                const newRes = findObjectOldConfig
                    ? {
                        ...deepDiff(newEl, findObjectOldConfig),
                        ...(newNesterArr.length > 0 && {
                            heating_zones: newNesterArr,
                        }),
                    }
                    : {
                        ...newEl,
                        ...(newNesterArr.length > 0 && {
                            heating_zones: newNesterArr,
                        }),
                    };
                if (Object.keys(newRes).length > 0) {
                    if (findObjectOldConfig !== null) {
                        let oldResult = {};
                        Object.keys(newRes).map((i) => {
                            //@ts-ignore
                            if (i !== 'heating_zones') {
                                count = count + 1;
                                return (oldResult = {
                                    ...oldResult,
                                    [i]: findObjectOldConfig[i],
                                    ...(oldNesterArr.length > 0 && {
                                        heating_zones: oldNesterArr,
                                    }),
                                });
                            }
                            return;
                        });
                        const id = generateMongoDBId();
                        resultAcc = [
                            ...resultAcc,
                            {
                                ...(Object.keys(oldResult).length > 0
                                    ? {
                                        old: oldResult,
                                    }
                                    : {
                                        old: 'нет',
                                    }),
                                new: newRes,
                                id: id,
                                key: key,
                                name: {
                                    new: el.name,
                                    old: oldResult.name ?? el.name,
                                },
                                idSensor: el.id,
                            },
                        ];
                    }
                    else {
                        //добавляем новый
                        const id = generateMongoDBId();
                        resultAcc = [
                            ...resultAcc,
                            {
                                new: el,
                                old: 'нет',
                                id: id,
                                key: key,
                                name: {
                                    new: el.name,
                                },
                                idSensor: el.id,
                                flag: 'Добавлен',
                            },
                        ];
                    }
                }
                return resultAcc;
            });
        }
        //если результат сравнения ни объект и ни массива ищем такой же в старом конфиге и записываем оба варианта в объект с ключами new и old
        if (typeof general_compare_result[key] === 'number' ||
            typeof general_compare_result[key] === 'string' ||
            typeof general_compare_result[key] === 'boolean') {
            const id = generateMongoDBId();
            count = count + 1;
            resultAcc = [
                ...resultAcc,
                {
                    old: exist_config[key],
                    new: general_compare_result[key],
                    id: id,
                    key: key,
                },
            ];
        }
        // ищем удаленный объект в старом конфиге
        const findDeleteObjectOldConfig = lodash.differenceBy(exist_config[key], general_compare_result[key], 'id');
        if (findDeleteObjectOldConfig.length > 0) {
            //добавляем в результат сравнения удаленный объект
            findDeleteObjectOldConfig.map((el) => {
                const id = generateMongoDBId();
                resultAcc = [
                    ...resultAcc,
                    {
                        new: el,
                        id: id,
                        old: 'нет',
                        key: key,
                        name: {
                            new: el.name,
                        },
                        idSensor: el.id,
                        flag: 'Удален',
                    },
                ];
            });
        }
        return resultAcc;
    }, []);
    return { compare_result: result, count };
}
